import { render } from "./RiepilogoGettoni.vue?vue&type=template&id=30b0540b&scoped=true"
import script from "./RiepilogoGettoni.vue?vue&type=script&lang=js"
export * from "./RiepilogoGettoni.vue?vue&type=script&lang=js"

import "./RiepilogoGettoni.vue?vue&type=style&index=0&id=30b0540b&scoped=true&lang=css"
import "./RiepilogoGettoni.vue?vue&type=style&index=1&id=30b0540b&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b0540b"]])

export default __exports__